module.exports = __webpack_public_path__ + "labioplastika_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_1_after.jpg
// module id = 1067
// module chunks = 0